// @flow
import * as React from 'react'
import { getStaticSlugsPaths } from '../../../helpers/nextHelpers'
import type { SlugsStaticType } from '../../../helpers/nextHelpers'
import { withRouter } from 'next/router'
import {
  getSlugsByCategoryTypeAsync
} from '../../../models/Category'
import { convertCategoryToCharacterBySlugProps } from '../../../models/Character'
import type { CharacterPropsType } from '../../../models/Character'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { CharacterDetail } from '@components/Character/CharacterDetail'
function Character (props: CharacterPropsType): React.Node {
  return (
    <DiscoverLayout title={`Listen to audiobooks featuring ${props.title} on Dipsea`} description={`Listen to audiobooks featuring ${props.title}, ${props.description || ''}`} imageUrl={props.imageUrl}>
      <CharacterDetail {...props} />
    </DiscoverLayout>
  )
}

export default withRouter(Character)

type ContextType = {
  params: {
    slug: string
  }
}

export async function getStaticProps (
  context: ContextType
): Promise<{ props: CharacterPropsType }> {
  const character = await convertCategoryToCharacterBySlugProps(context.params.slug)
  return { props: character }
}
export async function getStaticPaths (): Promise<SlugsStaticType> {
  const slugs = await getSlugsByCategoryTypeAsync('hunks')
  return getStaticSlugsPaths(slugs)
}
